import styled from 'styled-components'

const StyledCourseLibraryView = styled.div`
  .course-list {
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-gap: 2rem 1rem;
    align-items: start;
    overflow: hidden;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xs}px) {
    .course-list {
      grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
      grid-gap: 24px 20px;
    }
  }
`

export default StyledCourseLibraryView
